'use client';

import Image from 'next/image';

import { LineArrowRightIcon } from '@/app/_components/icons/line/LineArrowRightIcon';
import { cn } from '@/app/lib/utils/tailwindcss';

interface PointCardProps {
  teamSlug: string;
  label: string;
  value: string;
  onClick?: () => void;
  className?: string;
}

export default function PointCard({ teamSlug, label, value, onClick, className }: PointCardProps) {
  return (
    <button
      onClick={onClick}
      type="button"
      className={cn(
        'flex w-full flex-col gap-2.5 rounded-sm border-[0.5px] border-transparent bg-point-card',
        className,
      )}
    >
      <div className="flex w-full items-center justify-between px-5 py-4">
        <div className="flex items-center gap-2">
          <Image
            src={`https://cdn.kottonseed.io/assets/football/2026/${teamSlug}/icons/icon_illust_point.webp`}
            alt="포인트 아이콘"
            width={24}
            height={24}
          />
          <span className="typo-body-3 text-white">{label}</span>
        </div>
        <div className="flex items-center gap-0.5">
          <span className="typo-body-1 text-white">{value}</span>
          <LineArrowRightIcon color="#FFFFFF" size={14} />
        </div>
      </div>
    </button>
  );
}
